<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Device Models</span>
    </div>
    <div>
      <!-- Redirect Button -->
      <div class="button-group">
        @if (ModelFirmwareCreate) {
          <button
            type="button"
            class="primary-button"
            [routerLink]="['/device-model-details']"
          >
            Add Device Model <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="component-container">
    <!-- List Section -->
    <form [formGroup]="modelForm" novalidate>
      <div class="component-header">
        <h6 class="component-title">Device Models List</h6>
        <div class="component-actions">
          <app-common-search
            [initialSearchValue]="modelForm?.get('modelListSearch')?.value"
            matTooltip="Model Name | Model Code | Hw Version"
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Model Name</th>
              <th>Model Code</th>
              <th>Hw Version</th>
              @if (ModelFirmwareView || ModelFirmwareDelete) {
                <th>Action</th>
              }
            </tr>
          </thead>
          @if (modelList.length > 0) {
            <tbody>
              @for (
                item of modelList
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.modelName }}</td>
                  <td>{{ item.modelCode }}</td>
                  <td>{{ item.hwVersion }}</td>
                  <td>
                    <div class="action-buttons">
                      @if (ModelFirmwareView) {
                        <button
                          type="button"
                          class="primary-button view-button"
                          (click)="prePopulation(item._id)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      }
                      @if (ModelFirmwareDelete) {
                        <button
                          type="button"
                          class="primary-button delete-button"
                          (click)="delete(item._id)"
                        >
                          <mat-icon class="btn-icon">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (modelList.length === 0) {
            <tbody>
              <tr>
                <td colspan="10">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="totalLength"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </form>
  </div>
</div>
